module.exports = __webpack_public_path__ + "static/media/linkedIn-white.777680e2.svg";